import { z } from "zod";

export const DTODesignSystemVersionRoom = z.object({
  id: z.string(),
});

export const DTODesignSystemVersionRoomResponse = z.object({
  room: DTODesignSystemVersionRoom,
});

export type DTODesignSystemVersionRoom = z.infer<typeof DTODesignSystemVersionRoom>;
export type DTODesignSystemVersionRoomResponse = z.infer<typeof DTODesignSystemVersionRoomResponse>;
